import batchCreateFieldInstances from "./batchCreateFieldInstances";
import buildTableFieldsObjects from "./buildTableFieldsObjects";
import { handleBatchCrud } from "./handleBatchCrud";
import updateTable from "./updateTable";
import { bulkSaveFieldInstances } from "../db/queries/fieldInstanceQueries";
import { FieldInstance, FieldInstanceForResolver, FieldTemplate } from "db/definitions";
/**
 * Creates a determined number of rows to make for testing purposes.
 * @param num of the rows to make
 */
async function buildManyRows(
	num: number,
	originalParentFieldInstance: FieldInstance,
	headerMap: Record<string, FieldTemplate>,
	online: boolean,
	projectId: string,
	linkedAltIds?: Record<string, string>,
	linkedData?: Record<string, FieldInstance>,
): Promise<{ parentFieldCopy: FieldInstance; fieldsToReturn: FieldInstance[] }> {
	const parentFieldInstance = JSON.parse(JSON.stringify(originalParentFieldInstance));

	let fieldsToCreate: FieldInstanceForResolver[] = [];
	let fieldsToReturn: FieldInstance[] = [];
	let fieldsOrder = [...parentFieldInstance.fieldsOrder];
	let promises = [];
	// Share one map across all rows so LINK cells in every row get the same alt instance
	const sharedLinkedAltIds = linkedAltIds ?? {};
	for (let i = 0; i < num; i++) {
		const rowData = await buildTableFieldsObjects(parentFieldInstance, headerMap, online, projectId, sharedLinkedAltIds, linkedData);
		promises.push(rowData);
		const fieldInstancesToCreate = rowData.fieldArray;
		fieldsOrder.push(rowData.rowString);
		fieldsToCreate = fieldsToCreate.concat(fieldInstancesToCreate);
		fieldsToReturn = fieldsToReturn.concat(rowData.fullFieldArray);
	}
	// await Promise.all(promises);

	parentFieldInstance.fieldsOrder = fieldsOrder;
	const parentFieldCopy = JSON.parse(JSON.stringify(parentFieldInstance));
	parentFieldCopy.tableFields.items = parentFieldCopy.tableFields.items.concat(fieldsToReturn);
	await updateTable(parentFieldInstance, online);
	if (online) {
		await handleBatchCrud(fieldsToCreate, batchCreateFieldInstances, 25);
		parentFieldCopy.updatedAt = new Date().toISOString();
	} else {
		parentFieldCopy.updatedAt = new Date().toISOString();
		await bulkSaveFieldInstances(fieldsToCreate);
	}

	return {
		parentFieldCopy,
		fieldsToReturn,
	};
}

export default buildManyRows;
